import styled from 'styled-components'

export const KnowledgeCenterBoxWrapper = styled.div`
  position: absolute;
  top: ${props => props.position.top};
  right: ${props => props.position.right};
  bottom: ${props => props.position.bottom};
  left: ${props => props.position.left};
  transform: translate(-50%, -50%);
  width: 320px;
  
  @media only screen and (max-width: 1199px) {
    position: static;
    transform: translateX(0);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
  }
  @media only screen and (max-width: 767px) {
    width: auto;
  }
`